import { gql } from '@apollo/client';
import { CLIENT_FIELDS } from './client';
const CLIENT_GROUP_FIELDS = gql `
  ${CLIENT_FIELDS}
  fragment ClientGroupFields on ClientGroup {
    id
    clientId
    memberClientId
    client {
      ...ClientFields
    }
    memberClient {
      ...ClientFields
    }
    createdAt
    updatedAt
  }
`;
export const CLIENT_GROUPS = gql `
  ${CLIENT_GROUP_FIELDS}
  query CLIENT_GROUPS($clientId: Int!) {
    clientGroups(clientId: $clientId) {
      ...ClientGroupFields
    }
  }
`;
export const SAVE_CLIENT_GROUP = gql `
  ${CLIENT_GROUP_FIELDS}
  mutation SAVE_CLIENT_GROUP($input: ClientGroupInput!) {
    saveClientGroup(input: $input) {
      ...ClientGroupFields
    }
  }
`;
export const DELETE_CLIENT_GROUP = gql `
  mutation DELETE_CLIENT_GROUP($id: Int!) {
    deleteClientGroup(id: $id)
  }
`;
